import { FC, useCallback, useState } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';

import { fetchPollDetails, FormattedPollDetail } from '@utils/Poll';
import { useAuth } from '@hooks/Auth';

import HeaderImage from '@components/elements/HeaderImage';
import Checkbox from '@components/elements/Checkbox';
import ButtonMighty from '@components/elements/ButtonMighty';

import './PollReportPage.css';
import toast from 'react-hot-toast';
import useSwr, { mutate } from 'swr';
import {
  createPollReport,
  listPollReportsByPoll,
} from '@sdk/managers/PollsManager';
import { useGlobalContext } from '@context/customContext';

const WITHDRAW_REASONS = [
  'Nudity',
  'Violence',
  'Harassment',
  'Suicide or self-injury',
  'False information',
  'Spam',
  'Unauthorised sales',
  'Hate speech',
  'Terrorism',
  'Something else',
];

const PollReportPage: FC = () => {
  const {
    params: { pollId },
  } = useRouteMatch<{
    pollId: string;
  }>();
  const history = useHistory<any>();

  const { user, loading: authLoading, dbUser } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const { guest } = useGlobalContext();

  const { data } = useSwr<FormattedPollDetail>(
    pollId && authLoading === false
      ? ['/poll/detail', pollId, user === null]
      : null,
    fetchPollDetails
  );

  const [value, setValue] = useState<string>();

  const onSubmit = useCallback(async () => {
    // if (!dbUser?.id) return;
    if (!value) {
      return toast.error('Select a reason for reporting poll.');
    }
    setLoading(true);

    try {
      await toast.promise(
        createPollReport({
          title: 'User report',
          description: value,
          pollID: pollId,
          owner: dbUser?.username || guest ,
        }),
        {
          loading: 'Reporting Poll',
          success: 'Your report has been submitted',
          error: (err) => err.error || err.message || 'Failed to reprot poll',
        }
      );
      await mutate(['/poll/voted', pollId, dbUser?.id || guest]);
      setTimeout(async () => {
        // toast.success('Reported Poll.');
        history.replace(`/poll/${pollId}?action=report`);
      }, 600);
    } catch (err) {
      console.log('Failed to report poll error error', err);
    } finally {
      setLoading(false);
    }
  }, [dbUser, value, pollId, history, guest]);

  return (
    <div className="min-h-screen pb-32 bg-fixed bg-gray-darkest poll-x-pattern">
      <HeaderImage
        title={data?.poll.title || ''}
        titleSize={(data?.poll.title?.length || 0) > 15 ? 40 : 55}
        image={data?.poll.image?.url || 'image'}
        alt="profile picture"
      />
      <div className="container flex flex-col items-center mx-auto">
        <div className="p-4 w-108">
          <div className="p-4 text-white md:p-8 bg-gray-darkest">
            <h2 className="mb-6 text-2xl">Report Poll</h2>
            <div className="mb-6 space-y-4">
              {WITHDRAW_REASONS.map((reason, index) => {
                return (
                  <div
                    key={`withdraw-item-${index}`}
                    onClick={() => setValue(reason)}
                    role="button"
                    className="flex items-center"
                  >
                    <Checkbox checked={value === reason} readOnly />
                    <div className="ml-2 text-base">{reason}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="justify-center px-4 md:flex">
          <ButtonMighty
            onClick={onSubmit}
            disabled={loading}
            loading={loading}
            color="#ff001e"
            borderColor="#5600fb"
            textColor="#FFF"
            text="Report Poll"
            margin="0"
          />
        </div>
      </div>
    </div>
  );
};

export default PollReportPage;
